import React from 'react';
import { Cross, GitMerge, InfoCircle, Mail } from '@saleshandy/icons';
import Modal from '../../../../../../../shared/design-system/components/atoms/modal';
import { TestPreviewEmailResponse } from '../../../../../types';
import { accessibleOnClick } from '../../../../../../../shared/utils/accessible-on-click';
import EmailPreviewContent from '../../../../../../../shared/components/email-preview/email-preview-content';

const EmailViewModal: React.FC<{
  show: boolean;
  emailViewData: TestPreviewEmailResponse;
  onClose: () => void;
  showNote?: boolean;
}> = ({ show, emailViewData, onClose, showNote = false }) => (
  <Modal
    show={show}
    hideFooter
    backdrop="static"
    className="email-view-modal"
    titleContent={
      <div className="email-view-modal-header">
        <div className="email-view-modal-title">
          <div className="step-variant-number">
            <span className="step-number">
              Step {emailViewData?.stepNumber}
            </span>
            <span className="variant-number">
              {emailViewData?.variantNumber}
            </span>
          </div>
          <div className="sequence-name">
            <span className="sequence-name-icon">
              {emailViewData?.isSubsequence ? (
                <GitMerge height={14} width={14} color="#9CA3AF" />
              ) : (
                <Mail height={14} width={14} color="#3B82F6" />
              )}
            </span>
            <span>{emailViewData?.sequenceName}</span>
          </div>
        </div>
        <div
          className="email-view-modal-close-button"
          {...accessibleOnClick(onClose)}
        >
          <Cross height={24} width={24} />
        </div>
      </div>
    }
  >
    <div className="email-view-modal-body">
      <div className="email-view-modal-subject">
        <span className="email-view-modal-subject-label">Subject:</span>{' '}
        {emailViewData?.previewContent?.subject}
      </div>
      <EmailPreviewContent
        content={emailViewData?.previewContent?.body || ''}
        attachments={[]}
      />
      {showNote && (
        <div className="email-view-modal-note">
          <span className="email-view-modal-note-label">
            <InfoCircle color="#1D4ED8" /> Note:
          </span>
          <span className="email-view-modal-note-content">
            Merge tags will be replaced with actual data before sending the
            email.
          </span>
        </div>
      )}
    </div>
  </Modal>
);

export default EmailViewModal;
